import { createSelector } from '@reduxjs/toolkit';

import { GlobalState } from '@/redux/store';

const stateSelector = (state: GlobalState) => state;
const catalogItemsSlice = createSelector(stateSelector, (state) => state.catalogItems);

const idSelector = (_: GlobalState, id: number) => id;
const byIdSelector = createSelector(catalogItemsSlice, (state) => state.byId);

export const getCatalogItemIdsByCatalogId = createSelector([byIdSelector, idSelector], (byId, id) => byId[id] || []);

export const getCatalogItemsLoading = createSelector(catalogItemsSlice, (state) => state.loading);

export const getCatalogItemsPagination = createSelector(catalogItemsSlice, ({ pagination }) => pagination);
